<template>
    <router-link :to="{name: 'cycleitem',params: { courseId: course.id}}" class="cyclecard">
        <div class="cyclecard-body">
            <div class="clear">
                <div class="left"><h3 class="fs5">{{ course.title }}</h3></div>
                <div v-if="'DAYS_CARD'==course.type" class="right fs5">{{ course.useNum }}次</div>
                <div v-else class="right fs4">不限次数</div>
            </div>
            <div v-if="'DAYS_CARD'==course.type" class="clear fs2 mtn">有效期：{{ course.timeSpan }}天</div>
            <div v-else class="clear fs2 mtn">有效期：1个月</div>
        </div>
        <div class="cyclecard-footer mtw clear">
            <div class="left cyclecard-footer__price">{{ course.price }}</div>
            <div v-if="'DAYS_CARD'==course.type" class="right fs1 c6">*需要在线预约</div>
            <div v-else class="right fs1 c6">*随到随学，有专业教练指导</div>
        </div>
    </router-link>
</template>
<script>
export default {
    name: 'CycleCard',
    props: {
      course: { // 卡信息
        type: Object,
        required: true
      }
    }
}
</script>
<style lang="less" scoped>
@mg-default:.15rem;
.cyclecard{ 
    display: block;
    position: relative;
    height: 1.2rem;
    margin-top: .15rem;
    padding:.1rem; 
    font-size: .16rem;
    border-radius: .03rem; 
    box-shadow: rgba(222,195,155,.2) 0 0 .05rem; 
    color: #5f390c;
    z-index: 1;
    background: linear-gradient(to right bottom,rgba(222,195,155,.8),rgba(194,165,90,.8) 60%,rgba(244,215,178,.8));
    // &:before{
    //     content: 'cycle CARD';
    //     font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    //     display: block;
    //     position: absolute;
    //     top: 0; left: 0;
    //     width: 100%; line-height: 1.2rem;
    //     color: #f9f9f9;
    //     font-size: .5rem;
    //     text-align: center;
    //     z-index: 0;
    // }
    &-body{
        position: absolute;
        top: @mg-default; left: @mg-default; right: @mg-default;
        z-index: 1;
    }
    &-footer{
        position: absolute;
        bottom: @mg-default; left: @mg-default; right: @mg-default;
        &__price{ 
            color: #cd6c3b;
            &:before{
                content: '¥';
                font-size: .12rem;
                margin-right: .02rem;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CycleCard.vue